var exports = {
  "Nr": "CrosspostCommunityCard.module__card___SmdpOE",
  "Uo": "CrosspostCommunityCard.module__sheetCard___SmdpOE",
  "vK": "CrosspostCommunityCard.module__banner___SmdpOE",
  "_e": "CrosspostCommunityCard.module__bannerImage___SmdpOE",
  "Dw": "CrosspostCommunityCard.module__bannerScrim___SmdpOE",
  "Kk": "CrosspostCommunityCard.module__icon___SmdpOE",
  "rf": "CrosspostCommunityCard.module__body___SmdpOE",
  "$": "CrosspostCommunityCard.module__titleRow___SmdpOE",
  "fh": "CrosspostCommunityCard.module__nameText___SmdpOE",
  "h_": "CrosspostCommunityCard.module__description___SmdpOE",
  "qr": "CrosspostCommunityCard.module__footer___SmdpOE",
  "dJ": "CrosspostCommunityCard.module__stat___SmdpOE",
  "gW": "CrosspostCommunityCard.module__statDot___SmdpOE",
  "rR": "CrosspostCommunityCard.module__statDotOnline___SmdpOE" + " " + "CrosspostCommunityCard.module__statDot___SmdpOE",
  "rb": "CrosspostCommunityCard.module__statDotMembers___SmdpOE" + " " + "CrosspostCommunityCard.module__statDot___SmdpOE",
  "KA": "CrosspostCommunityCard.module__statText___SmdpOE",
  "lm": "CrosspostCommunityCard.module__notice___SmdpOE",
  "XI": "CrosspostCommunityCard.module__action___SmdpOE",
  "Lq": "CrosspostCommunityCard.module__loading___SmdpOE",
};

module.exports = exports;
